<template>
  <div class="com-filed clearfix">
    <div class="label"><span v-if="required" class="need">*</span>{{ label }}</div>
    <div class="content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComFiled',
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="postcss">
.com-filed {
  border-bottom: 1px solid #e4e4e4;
  line-height: 30px;
  padding: 15px 0;

  .label {
    float: left;
    width: 190px;
    padding-right: 10px;
    text-align: right;

    .need {
      color: #f00;
      margin-right: 3px;
    }
  }

  .content {
    margin-left: 190px;
  }
}
</style>
